// extracted by mini-css-extract-plugin
module.exports = {"card":"Main_card__1QRe8","required":"Main_required__2D3um","titlePaddingTop":"Main_titlePaddingTop__2qja7"};